module.exports = __webpack_public_path__ + "img/icon-fire.b73b6b3b.png";